export default __webpack_public_path__ + "static/media/nutriaDeRio.bba4e789.jpg";